"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.levelValues = exports.GENERIC_BRAND_NAME = exports.MAX_OPTION_LEVELS = void 0;
exports.optionCombos = optionCombos;
exports.comboKey = comboKey;
exports.variantNameFromOptions = variantNameFromOptions;
exports.missingCombos = missingCombos;
exports.brandedProductName = brandedProductName;
// Product with Options: up to 3 named levels (Form › Strain › Weight). Each
// full combination is one ordinary variant. Only the last level is sellable;
// barcodes, prices, promotions and stock stay on the variant exactly as today.
exports.MAX_OPTION_LEVELS = 3;
exports.GENERIC_BRAND_NAME = 'Generic';
const levelValues = (axis) => [...axis.values].sort((a, b) => a.sortOrder - b.sortOrder).map((v) => v.value);
exports.levelValues = levelValues;
function optionCombos(levels) {
    if (!levels.length)
        return [];
    return levels.reduce((acc, axis) => acc.flatMap((sel) => (0, exports.levelValues)(axis).map((v) => ({ ...sel, [axis.name]: v }))), [{}]);
}
function comboKey(levels, options) {
    if (!options || !levels.length)
        return null;
    const parts = levels.map((l) => options[l.name]);
    return parts.every((p) => typeof p === 'string' && p.length > 0) ? parts.join('|') : null;
}
// Two screens (GRN detail, adjustment detail) treat " - " inside a variant
// name as "already includes the product" — so it must never appear here.
// Owner rule (2026-10-06, final): each level renders as "<option name>: <value>",
// in level order, joined by a plain ASCII ", " (receipt printers) — e.g.
// Vein=Green, Size=16 Oz -> "Vein: Green, Size: 16 Oz". An empty value skips
// its level; an empty level name emits the value only.
function variantNameFromOptions(levels, options) {
    const clean = (t) => t.replace(/\s+-\s+/g, ' ').replace(/\s{2,}/g, ' ').trim();
    return levels
        .map((l) => {
        const value = clean(options[l.name] || '');
        if (!value)
            return '';
        const name = clean(l.name || '');
        return name ? `${name}: ${value}` : value;
    })
        .filter(Boolean)
        .join(', ')
        .replace(/\s+-\s+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
}
function missingCombos(levels, variants) {
    const have = new Set(variants
        .filter((v) => v.status !== 'deleted' && v.status !== 'inactive')
        .map((v) => comboKey(levels, v.options))
        .filter((k) => !!k));
    return optionCombos(levels).filter((c) => !have.has(comboKey(levels, c)));
}
// Whole-word: "Geek Bar" already brands "Geek Bar Pulse", "Geek Bar: Pulse", "Geek Bar-X" and
// "Geek Bar's X" (brand followed by a non-alphanumeric), but not "Geek Barista".
function brandedProductName(brand, base, skipRepeat = true) {
    const b = (brand || '').trim() || exports.GENERIC_BRAND_NAME;
    const n = base.trim();
    if (!n)
        return b;
    if (!skipRepeat)
        return `${b} ${n}`;
    const nl = n.toLowerCase();
    const bl = b.toLowerCase();
    return nl === bl || (nl.startsWith(bl) && !/[a-z0-9]/i.test(nl[bl.length])) ? n : `${b} ${n}`;
}
//# sourceMappingURL=optionLevels.js.map